var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video_open"},[_c('headd',{attrs:{"mobile_title":_vm.mobile_title}}),_vm._v(" "),_c('div',[_c('video',{attrs:{"controls":"","id":"myVideo","src":_vm.video_url,"autoplay":"autoplay","show-fullscreen-btn":"true","poster":_vm.img_url}})]),_vm._v(" "),_c('foot')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f736a8c0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/videoplay.vue
// module id = null
// module chunks = 